
// Current Plan Costs (#721 spec §8.2 step 7 / A.10; its own card since the
// round-2 spec §13.4, Kalena 2026-09-30): the current plans any option
// replaces, their summaries, the current drug plan's copay table and the
// current MAPD's network (the supp's too when an option is a move).
import card from '~/mixins/card'
import * as aep from '~/util/aep-recommendation'

export default {
    mixins: [card],
    props: {
        magicUrl: { type: String, default: '/' },
        mode: { type: [String, Object], default: 'default' },
        aep: { type: Boolean, default: null },
        index: { type: Number, default: null },
        comboIndex: { type: Number, default: null },
    },
    computed: {
        ctx () {
            return this.aepContext
        },
        replaced () {
            return (this.ctx?.replacedAll || []).map(p => this.summaryPlansMap[p.id]).filter(Boolean)
        },
        // (`title` is a prop of the card mixin)
        header () {
            return aep.currentCostsTitle(this.ctx)
        },
        intro () {
            return aep.currentCostsIntro(this.ctx)
        },
        anyMove () {
            return aep.options(this.ctx).some(o => o.move)
        },
        showNetwork () {
            return !!this.summaryCardsMap.providers_network
        },
        rxPlan () {
            return this.replaced.find(p => p.pdp || p.mapd_or_ma) || null
        },
        medPlan () {
            return this.replaced.find(p => p.supp || p.mapd_or_ma) || null
        },
    },
    methods: {
        engine (plan) {
            return this.ctx.plansById[plan.id]
        },
        // (`summary` is the summary record on the card mixin)
        currentSummary (plan) {
            return aep.currentSummaryHtml(this.ctx, this.engine(plan))
        },
    },
}
